export function GetGeolocation(callback: PositionCallback) {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(callback);
    }
}

export function GetDistanceFromLatLonInKm(lat1: number, lng1: number, lat2: number, lng2: number): number {
    let R = 6371; // Radius of the earth in km
    let dLat = deg2rad(lat2 - lat1);
    let dLon = deg2rad(lng2 - lng1);
    let a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c;
    return d;
}

function deg2rad(deg) {
    return deg * (Math.PI / 180)
}


// WEBPACK FOOTER //
// ./src/utils/Geolocation.tsx